/* ============================================================
   WHO MADE THIS™ — app JS
   AJAX cart drawer (/cart.js, /cart/add.js, /cart/change.js) ·
   countdown · free-shipping progress · in-cart upsells ·
   discount code (applied via /discount/CODE at checkout) ·
   gallery slider · real option pills (Color / Size…) OR bundle
   tiers · live viewers · random low-stock · sticky ATC ·
   social-proof popup · dwell-time discount popup.
   Public API: window.WMTCart.open() / .close() / .add(id, qty)
   Works even if the drawer markup is missing (falls back to /cart).
   ============================================================ */
(function () {
  'use strict';
  if (window.__wmtLoaded) return; /* script may be included by several sections */
  window.__wmtLoaded = true;

  function formatMoneyFactory(fmt) {
    fmt = (fmt || '${{amount}}').replace(/<[^>]*>/g, '');
    return function (cents) {
      var val = (cents / 100).toFixed(2);
      var whole = Math.floor(cents / 100).toString();
      return fmt
        .replace(/\{\{\s*amount\s*\}\}/, val.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole.replace(/\B(?=(\d{3})+(?!\d))/g, ','))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, val.replace('.', ','))
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, whole);
    };
  }

  function cartAddRequest(variantId, qty) {
    return fetch('/cart/add.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty || 1 })
    }).then(function (r) { if (!r.ok) throw r; return r.json(); });
  }

  /* ================= CART DRAWER ================= */
  var cdRoot = document.querySelector('[data-wmt-cd]');
  var WMTCart = {
    open: function () {},
    close: function () {},
    toast: function () {},
    /* fallback: no drawer on the page → add then go to /cart (native Shopify) */
    add: function (variantId, qty) {
      return cartAddRequest(variantId, qty).then(function () { window.location.href = '/cart'; });
    }
  };
  window.WMTCart = WMTCart;

  if (cdRoot) {
    var money = formatMoneyFactory(cdRoot.dataset.moneyFormat);
    var freeShip = parseInt(cdRoot.dataset.tierShip, 10) || 0;
    var cdMin = parseInt(cdRoot.dataset.countdownMinutes, 10) || 10;
    var state = { cart: null, busy: false, promo: '' };
    var q = function (sel) { return cdRoot.querySelector(sel); };

    var openDrawer = function () { cdRoot.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; refresh(); startCountdown(); };
    var closeDrawer = function () { cdRoot.classList.remove('is-open'); document.documentElement.style.overflow = ''; };
    cdRoot.querySelectorAll('[data-wmt-cd-close]').forEach(function (el) { el.addEventListener('click', closeDrawer); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

    var toastEl = document.querySelector('[data-wmt-toast]');
    var toastTimer;
    var toast = function (msg) {
      if (!toastEl) return;
      toastEl.innerHTML = '<span class="tick">✓</span> ' + msg;
      toastEl.classList.add('is-on');
      clearTimeout(toastTimer);
      toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2600);
    };

    var cdTimer, cdLeft = cdMin * 60;
    function startCountdown() {
      var el = q('[data-wmt-cd-timer]');
      if (!el || cdTimer) return;
      cdTimer = setInterval(function () {
        cdLeft = Math.max(0, cdLeft - 1);
        var m = Math.floor(cdLeft / 60), s = cdLeft % 60;
        el.textContent = m + ':' + (s < 10 ? '0' : '') + s;
        if (cdLeft === 0) { clearInterval(cdTimer); cdTimer = null; cdLeft = cdMin * 60; }
      }, 1000);
    }

    function render() {
      var cart = state.cart;
      if (!cart) return;
      cdRoot.querySelectorAll('[data-wmt-cd-count]').forEach(function (el) { el.textContent = cart.item_count; });
      document.querySelectorAll('[data-wmt-bubble-count]').forEach(function (el) { el.textContent = cart.item_count; });
      var sub = q('[data-wmt-cd-subtotal]'); if (sub) sub.textContent = money(cart.total_price);

      var box = q('[data-wmt-cd-items]');
      if (!cart.items.length) {
        box.innerHTML = '<div class="wmt-cd__empty"><span class="big">🛒</span>Your cart is empty.<br>Fill it with something gloriously pointless.</div>';
      } else {
        box.innerHTML = cart.items.map(function (i, idx) {
          var img = i.image ? '<img src="' + i.image + (i.image.indexOf('?') > -1 ? '&' : '?') + 'width=124" alt="" loading="lazy">' : '🛍️';
          var variant = (i.variant_title && i.variant_title !== 'Default Title') ? '<div class="wmt-cd-item__var">' + i.variant_title + '</div>' : '';
          return '<div class="wmt-cd-item">' +
            '<div class="wmt-cd-item__pic">' + img + '</div>' +
            '<div><div class="wmt-cd-item__name">' + i.product_title + '</div>' + variant +
            '<div><span class="wmt-cd-qty">' +
            '<button data-wmt-line="' + (idx + 1) + '" data-wmt-q="' + (i.quantity - 1) + '" aria-label="Decrease">−</button>' +
            '<span>' + i.quantity + '</span>' +
            '<button data-wmt-line="' + (idx + 1) + '" data-wmt-q="' + (i.quantity + 1) + '" aria-label="Increase">+</button>' +
            '</span><button class="wmt-cd-item__rm" data-wmt-line="' + (idx + 1) + '" data-wmt-q="0">Remove</button></div></div>' +
            '<div class="wmt-cd-item__price">' + money(i.final_line_price) + '</div></div>';
        }).join('');
      }

      var bar = q('[data-wmt-cd-ship-bar]'), msg = q('[data-wmt-cd-ship-msg]');
      if (bar && freeShip > 0) {
        var left = Math.max(0, freeShip - cart.total_price);
        msg.innerHTML = left > 0
          ? 'You’re <span class="amt">' + money(left) + '</span> away from <b>FREE shipping</b>'
          : '🎉 <b>FREE shipping unlocked!</b> Your feet thank you.';
        bar.style.width = Math.min(100, (cart.total_price / freeShip) * 100) + '%';
      }

      cdRoot.querySelectorAll('[data-wmt-up]').forEach(function (up) {
        var vid = parseInt(up.dataset.wmtUp, 10);
        var inCart = cart.items.some(function (i) { return i.variant_id === vid; });
        up.style.display = inCart ? 'none' : '';
      });
    }

    function refresh() {
      return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { state.cart = c; render(); return c; });
    }

    q('[data-wmt-cd-items]').addEventListener('click', function (e) {
      var b = e.target.closest('button[data-wmt-line]');
      if (!b || state.busy) return;
      state.busy = true;
      fetch('/cart/change.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: parseInt(b.dataset.wmtLine, 10), quantity: Math.max(0, parseInt(b.dataset.wmtQ, 10)) })
      }).then(function (r) { return r.json(); }).then(function (c) { state.cart = c; render(); state.busy = false; })
        .catch(function () { state.busy = false; });
    });

    var addToCart = function (variantId, qty) {
      return cartAddRequest(variantId, qty).then(function () {
        return refresh();
      }).then(function () {
        openDrawer(); toast('Added to your cart');
        document.dispatchEvent(new CustomEvent('wmt:cart:updated'));
      });
    };

    cdRoot.addEventListener('click', function (e) {
      var b = e.target.closest('[data-wmt-up-add]');
      if (b) addToCart(parseInt(b.dataset.wmtUpAdd, 10), 1);
    });

    var promoInput = q('[data-wmt-cd-promo-input]');
    var promoBtn = q('[data-wmt-cd-promo-apply]');
    var promoMsg = q('[data-wmt-cd-promo-msg]');
    if (promoBtn) promoBtn.addEventListener('click', function () {
      state.promo = (promoInput.value || '').trim().toUpperCase();
      if (promoMsg) promoMsg.textContent = state.promo ? '✓ Code "' + state.promo + '" will be applied at checkout' : '';
    });

    /* checkout — real Shopify checkout, promo applied via /discount/CODE */
    var checkoutBtn = q('[data-wmt-cd-checkout]');
    if (checkoutBtn) checkoutBtn.addEventListener('click', function () {
      window.location.href = state.promo ? '/discount/' + encodeURIComponent(state.promo) + '?redirect=/checkout' : '/checkout';
    });

    document.addEventListener('click', function (e) {
      var t = e.target.closest('[data-wmt-cart-open]');
      if (t) { e.preventDefault(); openDrawer(); }
    });
    if (cdRoot.hasAttribute('data-intercept-cart-links')) {
      document.addEventListener('click', function (e) {
        var a = e.target.closest('a[href="/cart"], a[href^="/cart?"]');
        if (a) { e.preventDefault(); openDrawer(); }
      });
    }

    WMTCart.open = openDrawer; WMTCart.close = closeDrawer; WMTCart.add = addToCart; WMTCart.toast = toast;
    refresh();
  }

  /* ================= PRODUCT PAGE ================= */
  var pp = document.querySelector('[data-wmt-pp]');
  if (pp) {
    var pq = function (sel) { return pp.querySelector(sel); };
    var pmoney = formatMoneyFactory(pp.dataset.moneyFormat);
    var rnd = function (min, max) { return Math.floor(Math.random() * (max - min + 1)) + min; };

    /* variants data (from Shopify) */
    var VARIANTS = [];
    var vEl = pq('[data-wmt-variants]');
    if (vEl) { try { VARIANTS = JSON.parse(vEl.textContent); } catch (err) {} }

    /* ---- gallery ---- */
    var track = pq('[data-wmt-gal-track]');
    var galleryGoTo = function () {};
    if (track) {
      var slides = track.children.length;
      var idxEl = pq('[data-wmt-gal-idx]');
      var thumbs = pp.querySelectorAll('[data-wmt-gal-thumb]');
      galleryGoTo = function (i) {
        i = Math.max(0, Math.min(slides - 1, i));
        track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
      };
      var current = function () { return Math.round(track.scrollLeft / track.clientWidth); };
      track.addEventListener('scroll', function () {
        var i = current();
        if (idxEl) idxEl.textContent = i + 1;
        thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); });
      }, { passive: true });
      var prev = pq('[data-wmt-gal-prev]'), next = pq('[data-wmt-gal-next]');
      if (prev) prev.addEventListener('click', function () { galleryGoTo(current() - 1); });
      if (next) next.addEventListener('click', function () { galleryGoTo(current() + 1); });
      thumbs.forEach(function (t) { t.addEventListener('click', function () { galleryGoTo(parseInt(t.dataset.wmtGalThumb, 10)); }); });
    }

    /* ---- live viewers ---- */
    var viewerEl = pq('[data-wmt-viewer-count]');
    if (viewerEl) {
      var vMin = parseInt(pp.dataset.viewerMin, 10) || 12, vMax = parseInt(pp.dataset.viewerMax, 10) || 38;
      viewerEl.textContent = rnd(vMin, vMax);
      setInterval(function () {
        var cur = parseInt(viewerEl.textContent, 10);
        viewerEl.textContent = Math.max(vMin, Math.min(vMax, cur + rnd(-2, 2)));
      }, 9000);
    }

    /* ---- random low stock ---- */
    var stockEl = pq('[data-wmt-stock-count]');
    if (stockEl) {
      var sMin = parseInt(pp.dataset.stockMin, 10) || 13, sMax = parseInt(pp.dataset.stockMax, 10) || 21;
      var sCap = parseInt(pp.dataset.stockCap, 10) || 45;
      var stock = rnd(sMin, sMax);
      stockEl.textContent = stock;
      var meter = pq('[data-wmt-stock-meter]');
      if (meter) meter.style.width = Math.min(96, 100 - (stock * 100 / sCap)) + '%';
    }

    /* ---- variant state ---- */
    var idInput = pq('[data-wmt-variant-id]');
    var atcBtn = pq('[data-wmt-atc]');
    var atcPrice = pq('[data-wmt-atc-price]');
    var qtyInput = pq('[data-wmt-qty]');
    var curQty = function () { return Math.max(1, parseInt(qtyInput && qtyInput.value, 10) || 1); };

    function syncPrices() {
      if (!idInput) return;
      var price = parseInt(idInput.dataset.price, 10) || 0;
      var compare = parseInt(idInput.dataset.compare, 10) || 0;
      var available = idInput.dataset.available === 'true';
      if (atcPrice) { atcPrice.textContent = pmoney(price * curQty()); atcPrice.hidden = !available; }
      if (atcBtn) {
        atcBtn.disabled = !available;
        var lbl = pq('[data-wmt-atc-label]');
        if (lbl) lbl.textContent = available ? (atcBtn.dataset.labelAdd || 'Add to Cart') : (atcBtn.dataset.labelSoldout || 'Sold out');
      }
      /* main price / save badge */
      var priceEl = pq('[data-wmt-price]'); if (priceEl) priceEl.textContent = pmoney(price);
      var cmpEl = pq('[data-wmt-compare]');
      if (cmpEl) { cmpEl.hidden = !(compare > price); if (compare > price) cmpEl.textContent = pmoney(compare); }
      var pct = compare > price ? Math.round((compare - price) / compare * 100) : 0;
      var badge = pq('[data-wmt-save-badge]');
      if (badge) {
        badge.hidden = pct <= 0;
        var pctEl = pq('[data-wmt-save-pct]'); if (pctEl) pctEl.textContent = pct;
      }
      var saveRow = pq('[data-wmt-price-save]');
      if (saveRow) {
        saveRow.hidden = pct <= 0;
        var pctEl2 = pq('[data-wmt-price-save-pct]'); if (pctEl2) pctEl2.textContent = pct;
      }
      /* sticky bar */
      var stB = pq('[data-wmt-sticky-price]'); if (stB) stB.textContent = pmoney(price);
      var stC = pq('[data-wmt-sticky-compare]');
      if (stC) { stC.hidden = !(compare > price); if (compare > price) stC.textContent = pmoney(compare); }
      var stN = pq('[data-wmt-sticky-name]'); if (stN) stN.textContent = idInput.dataset.name || '';
    }

    function setVariant(v) {
      if (!v) {
        idInput.dataset.available = 'false';
        idInput.dataset.name = 'Unavailable';
        syncPrices();
        var lbl = pq('[data-wmt-atc-label]'); if (lbl) lbl.textContent = 'Unavailable';
        return;
      }
      idInput.value = v.id;
      idInput.dataset.price = v.price;
      idInput.dataset.compare = v.compare_at_price || 0;
      idInput.dataset.available = String(v.available);
      idInput.dataset.name = (v.title !== 'Default Title') ? v.title : '';
      syncPrices();
      /* jump gallery to the variant's image */
      if (v.featured_image && typeof v.featured_image.position === 'number') {
        galleryGoTo(v.featured_image.position - 1);
      }
    }

    /* ---- real option pills (Color / Shoe Size…) ---- */
    var optGroups = pp.querySelectorAll('[data-wmt-opt]');
    function selectedOptions() {
      var opts = [];
      optGroups.forEach(function (g) {
        var sel = g.querySelector('.wmt-opt-pill.is-active');
        opts[parseInt(g.dataset.wmtOpt, 10)] = sel ? sel.dataset.wmtOptVal : null;
      });
      return opts;
    }
    function matchVariant(opts) {
      return VARIANTS.find(function (v) {
        return (opts[0] == null || v.option1 === opts[0]) &&
               (opts[1] == null || v.option2 === opts[1]) &&
               (opts[2] == null || v.option3 === opts[2]);
      }) || null;
    }
    function markAvailability() {
      var opts = selectedOptions();
      optGroups.forEach(function (g) {
        var gi = parseInt(g.dataset.wmtOpt, 10);
        g.querySelectorAll('.wmt-opt-pill').forEach(function (pill) {
          var test = opts.slice();
          test[gi] = pill.dataset.wmtOptVal;
          var v = matchVariant(test);
          pill.classList.toggle('is-oos', !v || !v.available);
        });
      });
    }
    optGroups.forEach(function (g) {
      g.addEventListener('click', function (e) {
        var pill = e.target.closest('.wmt-opt-pill');
        if (!pill) return;
        g.querySelectorAll('.wmt-opt-pill').forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-checked', 'false'); });
        pill.classList.add('is-active'); pill.setAttribute('aria-checked', 'true');
        var selLbl = g.querySelector('[data-wmt-opt-sel]'); if (selLbl) selLbl.textContent = pill.dataset.wmtOptVal;
        setVariant(matchVariant(selectedOptions()));
        markAvailability();
      });
    });
    if (optGroups.length) markAvailability();

    /* ---- bundle tiers (single-option products) ---- */
    pp.querySelectorAll('[data-wmt-tier]').forEach(function (tier) {
      tier.addEventListener('click', function () {
        if (tier.disabled) return;
        pp.querySelectorAll('[data-wmt-tier]').forEach(function (t) { t.classList.remove('is-active'); t.setAttribute('aria-checked', 'false'); });
        tier.classList.add('is-active'); tier.setAttribute('aria-checked', 'true');
        idInput.value = tier.dataset.id;
        idInput.dataset.price = tier.dataset.price;
        idInput.dataset.compare = tier.dataset.compare;
        idInput.dataset.available = tier.dataset.available;
        idInput.dataset.name = tier.dataset.name;
        syncPrices();
      });
    });

    /* ---- qty ---- */
    var dec = pq('[data-wmt-qty-dec]'), inc = pq('[data-wmt-qty-inc]');
    if (dec) dec.addEventListener('click', function () { qtyInput.value = Math.max(1, curQty() - 1); syncPrices(); });
    if (inc) inc.addEventListener('click', function () { qtyInput.value = Math.min(10, curQty() + 1); syncPrices(); });
    if (qtyInput) qtyInput.addEventListener('change', syncPrices);

    /* ---- ATC → AJAX drawer (or /cart fallback) ---- */
    var form = pq('[data-wmt-product-form]');
    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (!idInput || idInput.dataset.available !== 'true') return;
      atcBtn.disabled = true;
      window.WMTCart.add(parseInt(idInput.value, 10), curQty())
        .then(function () { atcBtn.disabled = false; })
        .catch(function () { atcBtn.disabled = false; alert('Could not add to cart. Please try again.'); });
    });
    var stickyAtc = pq('[data-wmt-sticky-atc]');
    if (stickyAtc) stickyAtc.addEventListener('click', function () {
      if (idInput && idInput.dataset.available === 'true') window.WMTCart.add(parseInt(idInput.value, 10), curQty());
    });

    /* ---- sticky bar visibility ---- */
    var sticky = pq('[data-wmt-sticky]');
    var hero = pq('[data-wmt-hero]');
    if (sticky && hero && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        sticky.classList.toggle('is-on', !entries[0].isIntersecting);
      }, { threshold: 0 }).observe(hero);
    }

    /* ---- social-proof popup ---- */
    var proofEl = pq('[data-wmt-proof]');
    var proofData = pq('[data-wmt-proof-data]');
    if (proofEl && proofData) {
      var people = [];
      try { people = JSON.parse(proofData.textContent); } catch (err) {}
      if (people.length) {
        var showProof = function () {
          var p = people[rnd(0, people.length - 1)];
          proofEl.querySelector('[data-wmt-proof-name]').textContent = p.name + ' (' + p.location + ')';
          proofEl.querySelector('[data-wmt-proof-action]').textContent = p.action;
          proofEl.querySelector('[data-wmt-proof-time]').textContent = rnd(2, 49) + ' minutes ago';
          proofEl.querySelector('[data-wmt-proof-avatar]').textContent = (p.name || '?').slice(0, 1).toUpperCase();
          proofEl.classList.add('is-on');
          setTimeout(function () { proofEl.classList.remove('is-on'); }, 5200);
        };
        setTimeout(function () {
          showProof();
          setInterval(showProof, rnd(11, 19) * 1000);
        }, 6000);
      }
    }

    /* ---- dwell discount popup ---- */
    var dpop = pq('[data-wmt-dpop]');
    if (dpop && pp.dataset.dwellMinutes) {
      var shown = false;
      setTimeout(function () {
        if (shown) return; shown = true;
        dpop.classList.add('is-on');
      }, (parseInt(pp.dataset.dwellMinutes, 10) || 5) * 60000);
      dpop.querySelectorAll('[data-wmt-dpop-close]').forEach(function (el) { el.addEventListener('click', function () { dpop.classList.remove('is-on'); }); });
      var copyBtn = dpop.querySelector('[data-wmt-dpop-copy]');
      if (copyBtn) copyBtn.addEventListener('click', function () {
        var code = dpop.querySelector('code').textContent;
        if (navigator.clipboard) navigator.clipboard.writeText(code);
        copyBtn.textContent = 'Copied!';
        setTimeout(function () { copyBtn.textContent = 'Copy'; }, 1600);
      });
      var applyBtn = dpop.querySelector('[data-wmt-dpop-apply]');
      if (applyBtn) applyBtn.addEventListener('click', function () {
        var code = dpop.querySelector('code').textContent;
        window.location.href = '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(window.location.pathname);
      });
    }

    syncPrices();
  }

  /* ================= HOME quick-add ================= */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wmt-quick-add]');
    if (!b) return;
    e.preventDefault();
    b.disabled = true;
    window.WMTCart.add(parseInt(b.dataset.wmtQuickAdd, 10), 1)
      .then(function () { b.disabled = false; })
      .catch(function () { b.disabled = false; });
  });
})();
